import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './app/i18n/global.js'
import './plugins/element.js'
import './services/service.js'
import * as filters from './global/filters.js'
import * as glb from './global/glbFunction.js'
import "lib-flexible-computer";
// import Echarts from "echarts"
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;
//用于关闭[Violation]警告
import 'default-passive-events'

//全局混入
import globalMixin from "@/app/common/mixin/mixin-global.js";
Vue.mixin(globalMixin);

// 导入全局样式
import './assets/css/global.css'
import './assets/css/Layout.css'
//导入iconfont symbol
import './assets/iconfont/iconfont.js'
import './assets/iconfont/iconfont.css'

//注册全局过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
//XSS防护
import VueDOMPurifyHTML from 'vue-dompurify-html'
Vue.use(VueDOMPurifyHTML)

Vue.prototype.$bus = new Vue(); //兄弟组件传值
Vue.config.productionTip = false

document.title = "APS-CN"

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')